import { Component } from '@angular/core';

@Component({
    selector: 'md-hotel-booking-loading',
    template: `
        <div class="loading-container">
            <div class="pdbc-dateguests-title">
                {{ 'Change rooms' | translate }}
            </div>
            <div class="pdbc-dateguests-subtitle">
                {{ 'For 2 Adults' | translate }}
            </div>
            <div
                mdSkeleton
                style="width:100%; height: 24px; border-radius: 4px; margin-bottom: 16px;"
            ></div>
            <div
                mdSkeleton
                style="width:100%; height: 24px; border-radius: 4px; margin-bottom: 16px;"
            ></div>
            <div
                mdSkeleton
                style="width:100%; height: 24px; border-radius: 4px; margin-bottom: 16px;"
            ></div>
            <div
                mdSkeleton
                style="width:100%; height: 24px; border-radius: 4px; margin-bottom: 16px;"
            ></div>
        </div>
        <div class="loading-container">
            <div class="pdbc-dateguests-title">
                {{ 'Upgrade meal plan' | translate }}
            </div>
            <div class="pdbc-dateguests-subtitle">
                {{ 'For 2 Adults' | translate }}
            </div>
            <div
                mdSkeleton
                style="width:100%; height: 24px; border-radius: 4px; margin-bottom: 16px;"
            ></div>
            <div
                mdSkeleton
                style="width:100%; height: 24px; border-radius: 4px; margin-bottom: 16px;"
            ></div>
            <div
                mdSkeleton
                style="width:100%; height: 24px; border-radius: 4px; margin-bottom: 16px;"
            ></div>
            <div
                mdSkeleton
                style="width:100%; height: 24px; border-radius: 4px; margin-bottom: 16px;"
            ></div>
        </div>
    `,
    styles: [
        `
            @import '/src/theme.scss';

            .loading-container {
                border-radius: 10px;
                border: 1px solid $gray-6;
                padding: $base-spacing * 4;
                margin-bottom: $base-spacing * 4;
            }

            .pdbc-dateguests-title {
                display: flex;
                flex-direction: row;
                align-items: center;
                font-size: $font-size-l;
                font-weight: $font-weight-semibold;
            }

            .pdbc-dateguests-subtitle {
                margin-bottom: $base-spacing * 2;
                font-size: $font-size-s;
                font-weight: $font-weight-semibold;
            }
        `,
    ],
})
export class HotelBookingLoadingComponent {}
